
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";

export abstract class AbSubIntegrador extends AppService {
  abstract desativar(id: number);
  abstract getAllSubIntegradores(filter: AppFilter);
  abstract saveSubIntegrador(form: any);
}